import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  TextField, InputAdornment, IconButton, Typography, List, ListItem, Box,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import {
  INPUT,
  DATE_TIME_FORMAT,
  MATCHING_COMPANY_TAB,
} from '../../../common/const';
import {
  setSystemLodingFLg,
  setInitMessage,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  setSelectSequenceId,
  setDispTab,
  setDispDate,
  setErrDispDate,
  searchMatchingJobList,
  filterJobList,
} from '../../actions/MatchingAction';
import validator from '../../../common/validator';
import styles from './MatchingJobListComponent.module.css';

class MatchingJobListComponent extends Component {
  /**
   * コンポーネント初期表示字の処理
   */
  componentDidMount() {
    const {
      dispDate,
      setDispDateAct,
    } = this.props;
    if (!dispDate) {
      // 表示日付が設定されていない場合、現在日付を設定
      setDispDateAct(moment().format(DATE_TIME_FORMAT.DATE));
    }
  }

  /**
   * 検索ボタン押下時の処理
   */
  onClickSearchButton = async () => {
    const {
      setDispTabAct,
      setSelectSequenceIdAct,
      setSystemLodingFLgAct,
      setInitMessageAct,
      setErrorMessageAct,
      setErrDispDateAct,
      dispDate,
      searchMatchingJobListAct,
    } = this.props;

    // 選択中シーケンスIDを初期化
    setSelectSequenceIdAct(null);

    // メッセージエリア初期化
    setInitMessageAct();
    const msgs = [];
    // 日付の必須チェック
    validator.checkRequired(INPUT.MATCHING.EXCUTION_DATE, dispDate, msgs);
    // 日付の妥当性チェック
    validator.checkIsDate(INPUT.MATCHING.EXCUTION_DATE, dispDate, msgs);
    if (msgs.length !== 0) {
      setErrorMessageAct(msgs);
      setErrDispDateAct(true);
      return;
    }

    // 表示タブを「マッチング設定」に設定
    setDispTabAct(MATCHING_COMPANY_TAB.SETTING);
    // エンターキー連打制御
    document.activeElement.blur();
    setErrDispDateAct(false);
    setSystemLodingFLgAct(true);
    // ジョブ一覧取得
    // API呼出し
    await searchMatchingJobListAct(dispDate);
    setSystemLodingFLgAct(false);
  }

  /**
   * ジョブ一覧シーケンス押下
   * @param {*} sequenceId 押下されたシーケンスID
   */
  onClickJobListLink = async (sequenceId) => {
    const {
      setSelectSequenceIdAct,
      setDispTabAct,
      filterJobListAct,
      setSystemLodingFLgAct,
    } = this.props;
    // 選択シーケンスIDを設定
    setSystemLodingFLgAct(true);
    await setSelectSequenceIdAct(sequenceId);
    setSystemLodingFLgAct(false);
    // ジョブ一覧から対象ジョブを抽出
    const ret = await filterJobListAct();
    if (ret) {
      // 表示タブを「マッチング結果」に設定
      setDispTabAct(MATCHING_COMPANY_TAB.RESULT);
    }
  }

  render() {
    const {
      dispDate,
      jobList,
      errDispDate,
      selectSequenceId,
      setDispDateAct,
    } = this.props;

    let list = <List className={`${styles.resultlistfield}`} />;

    if (jobList) {
      list = (
        <List className={`${styles.resultlistfield}`}>
          {jobList.map((result) => {
            // 作成日時
            const createTime = moment(
              result.upload_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
            ).format(DATE_TIME_FORMAT.TIME);
            // 件数
            const readCount = `${Number(result.input_count).toLocaleString()}件`;
            // ファイル名
            let fileName;
            if (result.file_name.length > 15) {
              fileName = result.file_name.substr(0, 11).concat('...');
            } else {
              fileName = result.file_name;
            }

            return (
              <ListItem
                key={result.seq_id}
                className={selectSequenceId === result.seq_id ? `${styles.row} ${styles.select}` : `${styles.row}`}
                onClick={() => this.onClickJobListLink(result.seq_id)}
              >
                <div className={`${styles.leftItem}`}>
                  <Typography className={`${styles.time}`}>{createTime}</Typography>
                </div>
                <div className={`${styles.centerItem}`}>
                  <Typography className={`${styles.filename}`}>{fileName}</Typography>
                </div>
                <div className={`${styles.rightItem}`}>
                  <Typography className={`${styles.readcount}`}>{readCount}</Typography>
                </div>
              </ListItem>
            );
          })}
        </List>
      );
    }
    return (
      <Box className={`${styles.matchingjoblist}`}>
        <Typography variant="subtitle1" component="div" className={`${styles.subtitleYearMonthDate}`}>年月日から検索</Typography>
        <TextField
          id="excutiondate"
          className={`${errDispDate ? styles.inputError : ''} `}
          variant="outlined"
          value={dispDate || ''}
          onChange={(ev) => setDispDateAct(ev.target.value)}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              this.onClickSearchButton();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" className={`${styles.inputAdornment}`}>
                <IconButton
                  color="primary"
                  onClick={() => this.onClickSearchButton()}
                  className={`${styles.iconButton} ${styles.tooltip}`}
                >
                  <SearchIcon className={`${styles.searchIcon}`} />
                  <div className={`${styles.description}`}>検索</div>
                </IconButton>
              </InputAdornment>
            ),
            classes: {
              notchedOutline: errDispDate ? styles.notchedOutlineError : styles.notchedOutline,
            },
            className: styles.inputPropsYearMonthDate,
          }}
          size="small"
          error={errDispDate}
        />
        {list}
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    dispDate: state.matching.dispDate,
    jobList: state.matching.jobList,
    selectSequenceId: state.matching.selectSequenceId,
    errDispDate: state.matching.errDispDate,
  }),
  (dispatch) => ({
    setDispDateAct: (dispDate) => dispatch(setDispDate(dispDate)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    setSelectSequenceIdAct: (sequenceId) => dispatch(setSelectSequenceId(sequenceId)),
    setErrDispDateAct: (bool) => dispatch(setErrDispDate(bool)),
    searchMatchingJobListAct: (excutionDate) => dispatch(searchMatchingJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
  }),
)(MatchingJobListComponent);
